export var getReturnToLoginError = function (state) {
    return state.login.returnToLoginError;
};
export var getLockedAccountUsername = function (state) {
    return state.login.lockedAccountUsername;
};
